<script>
import 'swiper/css/swiper.min.css' 
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import store from '../store/index.js';
import { findIndex, reduce } from 'lodash';

export default {
	data() {
        return {
            title: store.carSeries.title,
			list: store.carSeries.series.list,
			swiperOptionTab: {
				slidesPerView: 'auto',
				freeMode: true,
				// spaceBetween: 10,
				grabCursor: true,
				slideToClickedSlide: true
			},
			swiperOption: {
				slidesPerView: 'auto',
				centeredSlides: true,
				grabCursor: true,
				slideToClickedSlide: true
			},
			citys: store.citys
        }
    },
    computed: {
    	tabSwiper() {
        	return this.$refs.tabSwiper.swiper;
    	},
    	imgSwiper() {
        	return this.$refs.imgSwiper.swiper;
		},
		seriesId() {
			return store.form.series.id;
		},
		index() {
			return findIndex(this.list, item => item.id === this.seriesId); 
		},
		isShowCoupon() {
			return store.isShowCoupon;
		},
		couponValue() {
			return store.couponValue;
		}
		
	},
	methods: {
		change() {
			const item = this.list[this.imgSwiper.activeIndex];
			const prev = this.list[this.imgSwiper.previousIndex];
			if (item) {
				store.form.series.id = item.id;
				store.form.series.name = item.name;
				store.form.series.taskid = item.taskid;
			}
			// 埋点上报
			this.$clickMonitor.send({
				buttonId: `series-${item.id}-enter`,
				...store.getClickMonitorParams()
			});
			if (prev) {
				this.$clickMonitor.send({
					buttonId: `series-${prev.id}-leave`,
					...store.getClickMonitorParams()
				});
			}
		},
		tabClick(index) {
			this.imgSwiper.slideTo(index);
			this.transitionStart();
		},
		transitionStart() {
			const activeIndex = this.imgSwiper.activeIndex;
			const prevIndex = this.imgSwiper.previousIndex;
			const curTabItem = this.tabSwiper.slides[activeIndex];
			const prevTabItem = this.tabSwiper.slides[prevIndex];
			const curTabItemWidth = curTabItem.offsetWidth;
			const tabClientWidth = this.tabSwiper.width;
			const activeTableLeft = curTabItem.offsetLeft;
			const tabWidth = reduce(this.tabSwiper.slides, (width, item) => {
				width += item.offsetWidth;
				return width;
			}, 0);
			curTabItem.querySelector('.tab-item').style.background = 'rgba(255,65,65,1)';
			curTabItem.querySelector('.tab-item').style.color = 'rgba(255, 255, 255, 1)';
			if (prevTabItem) {
				prevTabItem.querySelector('.tab-item').style.background = 'rgba(247,120,120,.36)';
				prevTabItem.querySelector('.tab-item').style.color = 'rgba(255, 255, 255, .36)';
			}
			this.tabSwiper.setTransition(300);
			if (activeTableLeft < (tabClientWidth - curTabItemWidth) / 2) {
				this.tabSwiper.setTranslate(0);
			} else if (activeTableLeft > tabWidth - (curTabItemWidth + tabClientWidth) / 2) {
				this.tabSwiper.setTranslate(tabClientWidth - tabWidth);
			} else {
				this.tabSwiper.setTranslate((tabClientWidth - curTabItemWidth) / 2 - activeTableLeft);
			}
		},
		// 只有在车系HS5 和 20个城市时才显示 “点赞中国字样”
		isShowTag(item) {
			if(item.id == '5048' && this.citys.indexOf(parseInt(store.form.position.cityId)) > -1) {
				return true;
			} else {
				return false;
			}
		}
	},
    components: {
	    swiper,
	    swiperSlide
	},
    mounted() {
		this.$nextTick(() => {
			const tabSwiper = this.$refs.tabSwiper.swiper;
			const imgSwiper = this.$refs.imgSwiper.swiper;
			// tabSwiper.controller.control = imgSwiper;
			// imgSwiper.controller.control = tabSwiper;
			this.transitionStart();
			this.$watch('index', function () {
				imgSwiper.slideTo(this.index);
			}, {immediate: true});
			this.change();
		});
		
		this.$eventBus.$on('changeSeries', (index)=>{
			this.tabClick(index);
		})
    }
}
</script>

<template>
    <div class="wrap" id="seriesWrap">
    	<div class="title">
        	{{title}}
			<!-- <i class="title-icon"></i> -->
        </div>
        <div class="tab-swiper-wrap">
        	<swiper class="tab-swiper-inner" :options="swiperOptionTab" ref="tabSwiper">
        		<swiper-slide v-for="(slide, eq) in list" :key="slide.id">
					<!-- <span v-if="isShowTag(slide)" class="tag">点赞中国</span> -->
        			<div class="tab-item series-tab" :data-id="slide.id" @click="tabClick(eq)"><i v-if="eq == index"></i>{{slide.tabName}}</div>
        		</swiper-slide>
        	</swiper>
        </div>
        <div class="img-swiper-wrap">
        	<swiper
				class="img-swiper-inner"
				:options="swiperOption"
				ref="imgSwiper"
				@slideChange="change"
				@transitionStart="transitionStart"
			>
        		<swiper-slide v-for="slide in list" :key="slide.id" :data-id="slide.id">
        			<img :src="slide.image" alt="" class="slide-img">
        			<div class="slide-tip" v-if="slide.policy || isShowCoupon"><span v-if="slide.policy">{{slide.policy}}</span><span v-show="isShowCoupon">&nbsp;送{{couponValue}}元打车券</span> </div>
        		</swiper-slide>
        	</swiper>
        </div>
    </div>
</template>
<style lang="stylus" scoped>
.title
	text-indent -999px
	margin -.8rem auto 0 auto
	width 10.67rem
	height 4.16rem
	background: url("../../assets/title_zx_bg.png") no-repeat
	background-size 100%
	margin-top: -.95rem
.tab-swiper-wrap
	margin-bottom 1.066rem
	margin-top: -0.7rem;
	font-size 0
	.swiper-container 
		padding-top 0.7rem
	.swiper-slide
		width auto
		position relative
		.tag
			position absolute
			display inline-block
			width 2.6rem
			height 0.85rem
			line-height 0.85rem
			top -0.7rem
			left 2.8rem
			background #009AFF
			font-size 0.48rem
			color #ffffff
			text-align center
			border-radius 0.48rem 0.48rem 0.48rem 0rem
			z-index 1
	.tab-item
		margin 0 0.53rem
		padding 0 0.8rem
		width auto
		height 1.70rem
		line-height 1.71rem
		border-radius 2px;
		font-size 0.85rem;
		background: rgba(247,120,120,.36);
		color #D18686;
		transition all .225s ease
		position relative
		i 
			width 2px
			height 1.7rem
			border-radius 2px 0 0 2px
			background-color #fff
			position absolute
			top 0
			left 0
.img-swiper-wrap
	height 7.73rem
	.swiper-container
		height 100%
	.swiper-slide
		position relative
		width 15.47rem
		height 100%
		background #fff
		// background linear-gradient(360deg,rgba(255,255,255,1) 0%,rgba(255,239,205,1) 100%)
		background:linear-gradient(360deg,rgba(255,255,255,1) 0%,rgba(255,255,255,0) 100%);
		opacity 0.58
		border-radius 0.53rem
		transition all .225s ease
		transform scale(0.9)
		overflow hidden
	.slide-img
		position absolute
		bottom 0.8rem
		left 0
		right 0
		margin auto
		max-width 7rem
		max-height 6rem
		border-radius 10px
		transform scale(1.6)
	.slide-tip
		position absolute
		left 0
		top 0
		padding 0 0.48rem
		height: 1.55rem;
		line-height 1.55rem
		background #396A00
		color #fff
		font-weight 500
		font-size 0.64rem
		box-sizing border-box
		background:linear-gradient(205deg,rgba(255,180,41,1) 0%,rgba(251,96,27,1) 100%);
		border-radius: 0.53rem 0rem 0.91rem 0;
	.img-swiper-inner .swiper-slide-active
		transform scale(1)
		background: linear-gradient(180deg,rgba(255,255,255,0.18) 0%,rgba(255,170,170,1) 72%,rgba(255,210,210,1) 100%);
		box-shadow :0rem 0.21rem 0.37rem 0rem rgba(149,1,1,0.5);
		opacity 1

</style>